import "./AssessSubmit.scss";
import { observer } from "mobx-react";
import React, { Component } from "react";
import EmailToContinue from "./EmailToContinue";
import { assessStore, resultStore, authStore } from "../stores";
import { Background, Button } from "../lib";
import background from "../assets/assess-bkg-04.png";
import { ASSESS_TYPE_LEADER } from "./../constants";
import { Redirect } from "react-router-dom";

class AssessSubmit extends Component {
  render() {
    if (!authStore.auth && assessStore.type === ASSESS_TYPE_LEADER) {
      return <Redirect to="/signin" />;
    }
    if (resultStore.churchResponse) {
      return <Redirect to="/dashboard" />;
    }
    if (resultStore.localResponse) {
      return <Redirect to="/results" />;
    }
    return (
      <div className="AssessSubmit">
        <Background src={background} />
        <div className="AssessSubmit_wrapper">
          <div className="AssessSubmit_container">
            {assessStore.retake === true ? (
              <div>
                <Button onClick={assessStore.submitTeam}>Submit</Button>
              </div>
            ) : assessStore.type === ASSESS_TYPE_LEADER ? (
              <div>
                <h1 style={{ marginBottom: 10 }}>Ready to submit!</h1>
                <Button
                  styleType="primary"
                  onClick={() => assessStore.submitTeam(authStore.auth)}
                >
                  Submit
                </Button>
              </div>
            ) : (
              <EmailToContinue />
            )}
          </div>
        </div>
      </div>
    );
  }
}

AssessSubmit.displayName = "AssessSubmit";

export default observer(AssessSubmit);



// WEBPACK FOOTER //
// ./src/assess/AssessSubmit.js